import { useState, useEffect } from 'react';
import config from '../config';
import { enviarCorreo } from '../helpers/correo.helpers';

export function RequerimientoModalConfirmar({ requerimiento, onClose }) {
  const [filas, setFilas] = useState([]);
  const [mostrarTablaCC, setMostrarTablaCC] = useState(true);
  const [mostrarBotonCC, setMostrarBotonCC] = useState(true);
  const [emailFinal, setEmailFinal] = useState("");
  const [formCorreo, setFormCorreo] = useState({
    id:null,
    para: "",
    asunto: "",
    cliente: "",
    razon_social: "",
    texto_cuerpo: "A continuación, compartimos el requerimiento detallado que hemos preparado para proporcionarles una oferta que se ajuste a sus necesidades y expectativas. Por favor, revisar y no dude en ponerse en contacto con nosotros si tiene alguna pregunta o necesita más información.",
    cc: [], 
    modulo: "requerimientos"
  });

  // 🔍 Buscar email si no viene en el requerimiento
  useEffect(() => {
    if (requerimiento.email_solicitante) {
      setEmailFinal(requerimiento.email_solicitante);
    } else if (requerimiento.id_contacto) {
      fetch(`${config.apiBaseUrl}/contacto_2.php?id=${requerimiento.id_contacto}`)
        .then(res => res.ok ? res.json() : Promise.reject("Error al obtener contacto"))
        .then(data => {
          const contacto = Array.isArray(data) ? data[0] : data;
          const email = contacto?.email || "";
          setEmailFinal(email);
        })
        .catch(err => {
          setEmailFinal("");
        });
    }
  }, [requerimiento]);

  // 📥 Cargar emails CC
  useEffect(() => {
    fetch(`${config.apiBaseUrl}/email_cc.php`)
      .then(res => res.json())
      .then(data => {
        if (data && data[0]?.id_email_cc) setFilas(data);
      })
      .catch(() => setFilas([]));
  }, []);

  // 🧩 Reconstruir formCorreo cuando emailFinal esté listo
  useEffect(() => {
    if (!emailFinal) return;

    setFormCorreo(prev => {
      const nuevo = {
        ...prev,
        id: requerimiento.id_requerimiento,
        para: emailFinal,
        asunto: `[Vittamaq] Visita Técnica - Requerimiento N°: ${requerimiento.id_requerimiento} -  / ${requerimiento.nombre_obra} / ${requerimiento.nombre_cliente}`,
        cliente: requerimiento.nombre_contacto,
        razon_social: requerimiento.nombre_cliente,
      };
      return nuevo;
    });
  }, [emailFinal]);

  // 🧩 Actualizar CC cuando cambien las filas
  useEffect(() => {
    setFormCorreo(prev => ({
      ...prev,
      cc: filas.map(f => f.email_cc).filter(Boolean),
    }));
  }, [filas]);

  const handleRadioChange = (e) => {
    const si = e.target.value === "1";
    setMostrarTablaCC(si);
    setMostrarBotonCC(!si);
    setFilas([{ id_email_cc: 1, email_cc: "" }]);
  };

  const handleAgregarFila = () => {
    let siguienteId = 1;
    while (filas.some(f => f.id_email_cc === siguienteId)) siguienteId++;
    setFilas([...filas, { id_email_cc: siguienteId, email_cc: "" }]);
  };

  const handleInputChange = (id, campo, valor) => {
    setFilas(filas.map(f => f.id_email_cc === id ? { ...f, [campo]: valor } : f));
  };

  const handleEliminarFila = (id) => {
    if (filas.length > 1) {
      setFilas(filas.filter(f => f.id_email_cc !== id));
    } else {
      alert("Debe agregar al menos un email, o seleccione 'NO'.");
    }
  };

  const handleEnviarCorreo = async () => {
    try {
      const data = await enviarCorreo(formCorreo);
      if (data.message === "El correo electrónico ha sido enviado correctamente.") {
        alert("Correo enviado correctamente.");
        onClose();
      }
    } catch (error) {
      alert("Hubo un error al enviar el correo electrónico.");
    }
  };
  
  return (
    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="mb-0">Notificar Requerimiento</h4>
          <button onClick={onClose} className="btn-close"></button>
        </div>
        <div className="modal-body">
          <p className="fs-5 mb-2">
            ¿Está seguro que desea notificar el requerimiento: <span className="text-orange">{requerimiento.nombre_requerimiento}</span>?
          </p>
          <p>
            Se enviará por correo a: <span className="text-orange">{formCorreo.para || "—"}</span>
          </p>
          <p>¿Desea copiar a otras direcciones (CC)?</p>
          <div className="d-flex justify-content-md-between">
            <div>
              <input type="radio" className="btn-check" name="email_cc" id="email-cc-si" value="1" checked={mostrarTablaCC} onChange={handleRadioChange} />
              <label className="btn" htmlFor="email-cc-si">Sí</label>
              <input type="radio" className="btn-check" name="email_cc" id="email-cc-no" value="0" checked={!mostrarTablaCC} onChange={handleRadioChange} />
              <label className="btn" htmlFor="email-cc-no">No</label>
            </div>
            {mostrarBotonCC && (
              <button type="button" className="btn btn-dark btn-sm" onClick={handleAgregarFila}>
                <i className="bi-plus-circle"></i> Agregar
              </button>
            )}
          </div>
          {mostrarTablaCC && (
            <div className="mt-3">
              <table className="table mb-0">
                <thead>
                  <tr className="table-active">
                    <th>Email</th>
                    <th>Eliminar</th>
                  </tr>
                </thead>
                <tbody>
                  {filas.map((fila, index) => (
                    <tr key={index}>
                      <td>
                        <input className="form-control form-control-sm" type="text" value={fila.email_cc} onChange={(e) => handleInputChange(fila.id_email_cc, 'email_cc', e.target.value)} />
                      </td>
                      <td>
                        <button className="btn btn-outline-danger btn-sm" onClick={() => handleEliminarFila(fila.id_email_cc)}>
                          <i className="bi bi-trash3"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn btn-yellow" onClick={handleEnviarCorreo}>
            <i className="bi bi bi-send"></i> Notificar
          </button>
        </div>
      </div>
    </div>
  );
}
